import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './WorkflowTask.scss'
import HrbTranslate from '../../language/HrbTranslate';
import HelpLink from '../common/HelpLink';
import './NewWorkflowTask.scss';

const WorkflowTaskStep = (props) => {
    return (
        <Fragment>
            <div className='workflow-task-step'>
                <div className='workflow-task-step-title'>
                    <div className='workflow-task-step-title-label'>
                        <p className={classnames({
                                    'p2': !props.titleClassNames,
                                    [props.titleClassNames]: props.titleClassNames
                        })} >
                            <HrbTranslate text={props.title} params={props.titleParams || {}} />
                        </p>
                    </div>
                    <div className='workflow-task-step-help'>
                        {props.helpKey &&
                            <HelpLink helpKey={props.helpKey} />
                        }
                    </div>
                </div>
            </div>
        </Fragment> 
    );
}

WorkflowTaskStep.propTypes = {
    title: PropTypes.string.isRequired,
    titleClassNames: PropTypes.string,
    titleParams: PropTypes.object,
    helpKey: PropTypes.string,
}

export default WorkflowTaskStep